import md5 from 'md5'

/**
 * Get a gravatar url given an email address
 * @param  {String} email an email address
 * @param  {Number} size  size of image in pixels
 * @return {String}       gravatar url
 */
export default function getGravatarUrl (email, size) {
  if (!email) return

  return `https://www.gravatar.com/avatar/${md5(email)}?d=retro&s=${size}`
}



// WEBPACK FOOTER //
// ./modules/utils/getGravatarUrl.js